import * as Yup from "yup";

const userTextValidation = (name) => {
  return Yup.string().required(name);
};
// .matches(/^[a-zA-Z\s]*$/, "Only alphabets and spaces are allowed")
const userPassword = Yup.string()
  .required("Password is required")
  .min(8, "Password must be at least 8 characters long")
  .matches(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,}$/,
    "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
  );
const confirmPassword = Yup.string()
  .oneOf(
    [Yup.ref("user_password"), null],
    "Passwords do not match. Please try again."
  )
  .required("Confirm Password is required");
const userMobileno = Yup.string()
  .required("Mobile Number is required")
  .matches(/^\+\d{1,3}\s?\d{7,15}$/, "Mobile Number is required.")
  .test("valid-length", "Invalid Mobile Number ", (value) => {
    if (!value) return false;
    const numberWithoutCountryCode = value.replace(/^\+\d{1,3}\s?/, "");
    return numberWithoutCountryCode.length >= 7;
  });
// const userMobileno = Yup.string()
//   .required("Contact number is required")
//   .matches(/^\+?[0-9\s\-()]{7,15}$/, "Contact number is required");

const userNumberField = Yup.number()
  .typeError("Total cash compensation must be a number")
  .required("Total cash compensation is required");

const userEmail = Yup.string()
  .matches(
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    "Invalid email address"
  )
  .required("Email is required");

const isAdminEmail = Yup.string()
  .matches(
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    "Invalid email address"
  )
  .test(
    "is-slate-accelerator-email",
    "Email must be from the domain slate-accelerator.com",
    (value) => value && value.endsWith("@slate-accelerator.com")
  )
  .required("Email is required");

  

const candidateTotalAmount = Yup.number()
  .typeError("Amount must be a number")
  .required("Amount is required")
  .positive("Amount must be positive");

export const jobIndustrySchema = Yup.string()
  .min(2, "Industry must be at least 2 characters")
  .max(100, "Industry cannot exceed 100 characters")
  .required("Industry is required");

export const achievementsSchema = Yup.string()
  .min(10, "Achievements must be at least 10 characters")
  .max(500, "Achievements cannot exceed 500 characters")
  .required("Achievements are required");
export const companyName = Yup.string()
  .min(2, "Company name must be at least 2 characters")
  .max(120, "Company name cannot exceed 120 characters")
  .required("Company name is required");

export const jobTitleSchema = Yup.string()
  .min(2, "Job Title must be at least 2 characters")
  .max(100, "Job Title cannot exceed 100 characters")
  .required("Job Title is required");
export const textLengthValidation = (name) => {
  return Yup.string()
    .min(2, `${name} must be at least 2 characters`)
    .max(100, `${name} cannot exceed 100 characters`)
    .required(`${name} is required`);
};

// candidate_bonusamount: Yup.number()
//   .typeError("Bonus amount must be a number")
//   .required("Bonus amount is required")
//   .positive("Bonus amount must be positive"),

// const userMobileno = Yup.string()
//   .required("Contact number is required")
//   .matches(
//     /^\+(\d{1,4})\s*\(?\d{1,4}\)?\s*\d{1,4}[-\s]?\d{1,4}[-\s]?\d{1,9}$/,
//     "Invalid contact number."
//   );
// const userMobileno = Yup.string()
//   .required("Contact number is required")
//   .matches(/^\+?[0-9]{7,15}$/, "Invalid contact number");

export {
  userPassword,
  confirmPassword,
  userMobileno,
  userEmail,
  userTextValidation,
  userNumberField,
  candidateTotalAmount,
  isAdminEmail,
};
